export const initialState = {
  directoryBasic: {},
  directoryController: {},
  directoryImage: {},
  directoryImageController: {},
  directoryServices: { serviceCounter: 0, data: [] },
  directoryProducts: { product_counter: 0, data: [] },
};
